import moment from "moment";

export default function ruleFormValidation(report) {
  // returned, defines if we have errors or not;
  let hasErrors = false;

  // returned, used to setState to inform the users of the errors;
  const errors = {};

  // rule name is required;
  if (report.name === ``) {
    errors.name = "Rule Name is a required field.";
    hasErrors = true;
  }

  // if pod, make sure a pod is required;
  if (report.sourceType === `pod`) {
    if (report.pod === null) {
      errors.pod = true;
      hasErrors = true;
    }

    // if campaign, make sure a campaign is required;
  } else {
    if (report.campaign === null) {
      errors.campaign = true;
      hasErrors = true;
    }
  }

  // show and/or timeslots are required:
  if (report.airtimeType === `timeSlots`) {
    if (report.timeslots && report.timeslots.length === 0) {
      errors.timeslots = true;
      hasErrors = true;
    }
  } else {
    if (report.shows && report.shows.length === 0) {
      errors.shows = true;
      hasErrors = true;
    }
  }

  // for Show-based, at least one position is also required
  if (report.airtimeType === `showBased`) {
    if (
      report.position_before_show === false &&
      report.position_after_show === false
    ) {
      errors.position = true;
      hasErrors = true;
    }
  }

  // if the dates are defined (always should be...);
  if (report.startDateValidate && report.endDateValidate) {
    // and they dates are the same, they're good to go;
    if (report.startDateValidate.isSame(report.endDateValidate) === false) {
      // if the start date is after the end date we have a problem;
      if (report.startDateValidate.isAfter(report.endDateValidate)) {
        errors.startDate = true;
        errors.endDate = true;
        hasErrors = true;
      }
    }
  }

  // for Show-based, the end date cannot be longer than 2 months
  if (report.airtimeType === `showBased`) {
    const afterTwoMonths = moment().add(60, `days`);
    if (report.endDateValidate.isAfter(afterTwoMonths)) {
      errors.showBasedEndDate =
        "For Show-based Rules the last possible day is: " +
        afterTwoMonths.format(`MM/DD/YYYY`);
      hasErrors = true;
    }
  }

  return {
    errors: errors, // return for setState to tell the user what went wrong;
    hasErrors: hasErrors // return true/false so the submit works/doesn't;
  };
}
